import React, { useEffect, useState } from 'react';
import { Card, Spin, Typography, Alert } from 'antd';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useParams } from 'react-router-dom';
import '../styles/markdown.css';

const { Title } = Typography;

// Markdown 文档映射
const DOC_MAP: { [key: string]: { title: string; file: string } } = {
  manual: {
    title: '使用文档',
    file: '/docs/使用文档.md',
  },
};

const Docs: React.FC = () => {
  const { docType } = useParams<{ docType: string }>();
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');

  const currentDoc = DOC_MAP[docType || 'manual'];

  useEffect(() => {
    const loadMarkdown = async () => {
      if (!currentDoc) {
        setError('文档不存在');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError('');

        const response = await fetch(currentDoc.file);
        if (!response.ok) {
          throw new Error('无法加载文档');
        }

        const text = await response.text();
        setContent(text);
      } catch (err) {
        console.error('加载文档失败:', err);
        setError('加载文档失败，请稍后重试');
      } finally {
        setLoading(false);
      }
    };

    loadMarkdown();
  }, [docType, currentDoc]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '100px 0' }}>
        <Spin size="large" />
        <div style={{ marginTop: 16 }}>加载文档中...</div>
      </div>
    );
  }

  if (error || !currentDoc) {
    return (
      <Card>
        <Alert
          message="错误"
          description={error || '文档不存在'}
          type="error"
          showIcon
        />
      </Card>
    );
  }

  return (
    <Card>
      <Title level={2}>{currentDoc.title}</Title>
      <div
        className="markdown-body"
        style={{
          fontSize: '14px',
          lineHeight: '1.8',
          color: 'rgba(0, 0, 0, 0.85)',
        }}
      >
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
          {content}
        </ReactMarkdown>
      </div>
    </Card>
  );
};

export default Docs;

